import { render, staticRenderFns } from "./TradeIn.vue?vue&type=template&id=60ced35c&scoped=true"
import script from "./TradeIn.vue?vue&type=script&lang=js"
export * from "./TradeIn.vue?vue&type=script&lang=js"
import style0 from "./TradeIn.vue?vue&type=style&index=0&id=60ced35c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ced35c",
  null
  
)

export default component.exports